import { Tag } from "@mui/icons-material";
import React, { memo } from "react";
import { NodeCard, valuePill } from "./commonNode";

const accent = "#2563eb";

export default memo(({ data, isConnectable, id }) => (
  <NodeCard
    id={id}
    title="Tag"
    accent={accent}
    icon={<Tag sx={{ width: 15, height: 15, color: accent }} />}
    isConnectable={isConnectable}
    targetTop="50%"
    sourceHandles={[{ id: "a", top: "72%" }]}
  >
    <div style={valuePill(accent)}>
      {data?.tag?.name || "Tag não selecionada"}
    </div>
  </NodeCard>
));
